import classNames from 'classnames';
import * as React from 'react';

interface ConnectionLineProps {
  hideBracket?: boolean;
  width?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function ConnectionLine(props: ConnectionLineProps) {
  const { hideBracket = true, className = 'relative', style, width = 12 } = props;

  return (
    <div className={classNames(className)} style={style}>
      {!hideBracket && (
        <svg
          className='absolute top-0'
          xmlns='http://www.w3.org/2000/svg'
          width={width}
          height='4'
          preserveAspectRatio='xMidYMid meet'
          viewBox='0 0 16 4'
          fill='none'
        >
          <path
            d={`
          M1 0 
          L5 0
        `}
            stroke='#4C4F5E'
            strokeWidth={2}
          />
        </svg>
      )}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height='100%'
        preserveAspectRatio='none'
        viewBox='0 0 12 20'
        fill='none'
      >
        <path
          d={`
          M1 0 
          L1 20
        `}
          stroke='#FFFFFF1F'
          strokeWidth={1}
        />
      </svg>
      {!hideBracket && (
        <svg
          className='absolute bottom-0'
          xmlns='http://www.w3.org/2000/svg'
          width={width}
          height='4'
          preserveAspectRatio='xMidYMid meet'
          viewBox='0 0 16 4'
          fill='none'
        >
          <path
            d={`
          M1 4 
          L5 4
        `}
            stroke='#4C4F5E'
            strokeWidth={2}
          />
        </svg>
      )}
    </div>
  );
}
